import { Component, OnInit } from '@angular/core';
import { Message } from '../../../../shared/message';
import { Helper } from '../../../../shared/helper';
import { Cache } from '../../../../shared/cache';
import { LevelService } from '../../../../account/services/level.service';
import { AppModule } from '../../../../app.module';
import { ActivatedRoute } from '../../../../../../node_modules/@angular/router';
import { ApplicationSettingService } from '../../../../adminision/services/application-setting.service';
import { StudentService } from '../../../services/student.service';
import { DivisionService } from '../../../../account/services/division.service';
import { HashTable } from 'angular-hashtable';
import { Auth } from 'src/app/shared/auth';
import { exit } from 'process';
import { GlobalService } from 'src/app/shared/services/global.service';
import { ApplicationHelper } from 'src/app/adminision/components/application/application-helper';
import { UserProfileService } from 'src/app/user-profile/user-profile.service';

@Component({
  selector: 'app-student-create',
  templateUrl: './student-create.component.html',
  styleUrls: ['./student-create.component.scss']
})
export class StudentCreateComponent implements OnInit {
displaylic="none"
  public doc: any = AppModule.doc;
  /**
   * application object
   */
  public application: any = {};

  public applicationSettings = ApplicationSettingService;

  public defaultImage: string = '/assets/img/avatar.png';

  public isSubmitted: any = false;

  public gradeError: string;

  public currentError: string;

  public isUpdate = false;

  public levels: any;
  public divisions: any;

  public requiredDocumentList = new HashTable<any, any>();

  public required_field = [
    'name',
    // 'qualification_id',
    'national_id' ,
    // 'registration_status_id',
    // 'academic_years_id',
    // 'grade',
    // 'qualification_date',
    // 'qualification_types_id',
    // 'level_id',
    // 'department_id',
    // 'case_constraint_id',
    // 'division_id',
    // 'gender'
  ];

  public col = "col-lg-10 col-md-10 col-sm-12";

  constructor(  private applicationSettingService : ApplicationSettingService,
private studentService: StudentService, private route: ActivatedRoute , private globalService : GlobalService, private service:UserProfileService) {
    const id = this.route.snapshot.params['id'];
    if (id > 0) {
      !Auth.can('student_edit')? exit() : '';
      this.loadApplication(id);
      this.isUpdate = true;
    } else {
      !Auth.can('student_add')? exit() : '';
    }
this.getNationalities()
this.getQualificationTypes()
    this.route.queryParams.subscribe((params) => {
      let col = params['col'];
      if (col)
        this.col = col;
    });
  }
  setDefaultYear() {
    this.application.nationality_id=1

    let yearId = this.currentAcademicYearId();

    if (yearId) {
      this.application.academic_years_id = yearId;
    } else {
      // الاعدادات لم تصل بعد: اجلبها ثم اضبط السنة
      this.applicationSettingService.getSettings().subscribe((res: any) => {
        this.applicationSettings.SETTINGS = res;

        // في وضع التعديل تكون بيانات الطالب قد حُمّلت، فلا تُدهس سنته
        if (this.isUpdate)
          return;

        this.application.academic_years_id = this.currentAcademicYearId();
      });
    }
  }

  /**
   * السنة الدراسية الحالية من اعدادات النظام (globale_settings id 7).
   * كانت مثبتة على 11 (2024-2025) فكانت شاشة الانشاء تفتح على سنة قديمة
   * بعد كل ترحيل. ترجع null ان لم تكن الاعدادات قد وصلت بعد.
   */
  currentAcademicYearId() {
    let yearId = null;

    (this.applicationSettings.SETTINGS || []).forEach((element: any) => {
      if (element.id == 7)
        yearId = parseInt(element.value);
    });

    return yearId ? yearId : null;
  }
  loadApplication(id) {
    this.studentService.load(id).subscribe((res: any) => {

      // -----new load registration status documents
      this.globalService.get('adminision/get_registeration_status_document').subscribe(documents => {
        this.applicationSettings.REGSITERATIN_STATUS_DOCUMENTS = documents
        this.validateOnRegisterationStatusDocument(res.registration_status_id)
      })


      this.application = res;
      this.loadStudentNotes(id);
    });
  }

  // ملاحظات الطالب المسجلة من شاشة الارشاد الاكاديمي، تُعرض هنا في ملفه
  // مع امكانية التعديل و الحذف.
  studentNotes: any[] = [];
  editingNoteId: any = null;
  editingNoteText = '';

  loadStudentNotes(id) {
    if (!id) {
      this.studentNotes = [];
      return;
    }

    this.studentService.getStudentNotes(id).subscribe((res: any) => {
      this.studentNotes = (res && res.status == 1 && res.data) ? res.data : [];
    }, () => {
      this.studentNotes = [];
    });
  }

  startEditNote(note) {
    this.editingNoteId = note.id;
    this.editingNoteText = note.notes;
  }

  cancelEditNote() {
    this.editingNoteId = null;
    this.editingNoteText = '';
  }

  saveEditNote(note) {
    const text = (this.editingNoteText || '').trim();

    if (!text) {
      Message.error('الملاحظة لا يمكن ان تكون فارغة');
      return;
    }

    this.studentService.updateStudentNote(note.id, { notes: text }).subscribe((res: any) => {
      if (res.status == 1) {
        Message.success('تم تعديل الملاحظة');
        this.cancelEditNote();
        this.loadStudentNotes(this.application.id);
      } else {
        Message.error(res.message);
      }
    });
  }

  deleteNote(note) {
    Message.confirm('هل تريد حذف هذه الملاحظة؟', () => {
      this.studentService.deleteStudentNote(note.id).subscribe((res: any) => {
        if (res.status == 1) {
          Message.success('تم حذف الملاحظة');
          this.loadStudentNotes(this.application.id);
        } else {
          Message.error(res.message);
        }
      });
    });
  }
  validateOnNationalId() {
    var message = Helper.trans("national id is not valid");
    var self = this;

    // get birth date from national id
    this.application.birthdate = ApplicationHelper.getBirthdate(this.application.national_id);
    this.calculateAge();

    // get gender from national id
    this.application.gender = ApplicationHelper.getGenderFromNationalId(this.application.national_id);

    /*if (!ApplicationHelper.validateOnNationalId(this.application.national_id, this.application.birthdate)) {

      this.setCurrentError(message);
      Message.confirm(message, function(){
        self.$('.national_id')[0].focus();
      }, () => {
        self.$('.national_id')[0].focus();
      });

    } else {
      this.setCurrentError("");
    }*/

    // set gender
  }
   Nationalities=[]
  getNationalities() {
     this.applicationSettingService.getNationalities().subscribe((res: any) => {

        this.Nationalities = res;
        
      });
   }
 QualificationTypes=[]
  getQualificationTypes() {
     this.applicationSettingService.getQualificationTypes().subscribe((res: any) => {

        this.QualificationTypes = res;
        
      });
   }

   
  calculateAge() {
    if (!this.application.birthdate)
      return 0;

    var years = 0;
    try {
      var calcDate = new Date();
      calcDate.setMonth(9);
      calcDate.setDate(1);

      var birthdate = this.application.birthdate;
      var bDate = new Date(birthdate);

      var diffTime = calcDate.getTime() - bDate.getTime();
      console.log("diffTime : ", diffTime);

      years = parseInt((diffTime / (24 * 60 * 60 * 1000 * 365)) + "");
      this.application.years = years;
    } catch (error) {
      console.log(error);
    }
    return years;
  }
  validate() {
    let valid = true;

    this.required_field.forEach(element => {
      if (!this.application[element])
        valid = false;
    });

    return valid;
  }

  validateOnRegisterationStatusDocument(registration_status_id=this.application.registration_status_id) {
    this.requiredDocumentList = new HashTable();
    this.applicationSettings.REGSITERATIN_STATUS_DOCUMENTS.forEach(element => {
      if (element.registeration_status_id	 == registration_status_id) {
        this.requiredDocumentList.put(element.required_document_id, 1);
      }
    });
  }

  sendApplication() {
    if (!this.validate()) {
      this.setCurrentError(Helper.trans('fill all requird data'));
      return Message.error(Helper.trans('fill all requird data'));
    }
    if (this.isUpdate)
      this.performUpdateApplication();
    else
      this.performSendApplication();
  }

  performUpdateApplication() {
    this.isSubmitted = true;
    let data = new FormData();
    for(let key of Object.keys(this.application)) {
      if(this.application[key])
        data.append(key, this.application[key]);
    }

    //return console.log(data);
    this.studentService.update(data).subscribe((res)=>{
      const data: any = res;

      if (data.status == 1)  {
        Message.success(data.message);
      }
      else {
        Message.error(data.message);
        this.setCurrentError(data.message);
      }
      this.isSubmitted = false;
    });
  }

  performSendApplication() {
    this.isSubmitted = true;
    let data = new FormData();
    for(let key of Object.keys(this.application)) {
      if(this.application[key])
      // console.log(key , this.application[key]);

        data.append(key, this.application[key]);
    }

    // return console.log(data);

    this.studentService.store(data).subscribe((res)=>{
      console.log(res);

      const data: any = res;

      if (data.status == 1)  {
        Message.success(data.message);
        this.reset();
      }
      else {
        Message.error(data.message);
        this.setCurrentError(data.message);
      }

      this.isSubmitted = false;
    });
  }

  reset() {
    this.application = {};
    this.currentError = '';
  }

  setCurrentError(error) {
    if (!error)
      return;
    error = error.replace(/<br>/g, '\n');
    this.currentError = error;
  }

  toggle(selector) {
    if (selector) {
      this.doc.jquery('.application-panel').slideUp(500);
      this.doc.jquery('.'+selector).slideDown(500);
    } else {
      this.doc.jquery('.application-panel').slideDown(500);
    }
  }


  setFile(event, key, required_document_id=null) {
    this.application[key] = event.target.files[0];
    console.log(this.application[key]);

    if (required_document_id) {
      if (!this.application[key])
        this.requiredDocumentList.put(required_document_id, 1);
      else
        this.requiredDocumentList.put(required_document_id, 2);
    }
  }

  viewPersonalImage(event) {
    this.setFile(event, 'personal_photo');
    var reader = new FileReader();
    reader.readAsDataURL(this.application.personal_photo);
    reader.onload = (_event) => {
      this.application.personal_photo_url = reader.result;
    }
  }

  emptyData() {
    this.application.qualification_types_id = null;
    this.application.level_id = null;
    this.application.level_name = null;
    this.application.grade = 0;
  }

  filterDataBaisedOnGender() {
    /*if (this.application.gender == 'female') {
      this.doc.jquery('.military-info-panel').hide();
      this.doc.jquery('.military-info-button').hide();
    } else {
      this.doc.jquery('.military-info-panel').show();
      this.doc.jquery('.military-info-button').show();
    }*/
  }

  ngOnInit() {
    this.loadProfile() 
    this.levels = Cache.get(LevelService.LEVEL_PREFIX);
    this.divisions = Cache.get(DivisionService.DIVISION_PREFIX);
    //
    this.application.old_balance_notes = "باقى رسوم سابقه عن عام ";
    this.setDefaultYear()
  }
  user:any={}
  isdis=false
  loadProfile() {
     this.service.getProfile().subscribe((res: any) => {
       debugger
        this.user = res.user;
        if(this.user.role_id==22){
          this.isdis=true
        }
        else{
          this.isdis=false
        }
      });
   }
 
}
